/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';
import { labels } from '../../data/labels';
import MultipleBets from './MultipleBets';
import SingleBets from './SingleBets';
import SystemBets from './SystemBets';

function Coupon(props) {
    const betslipContext = React.useContext(BetslipContext);

    const couponKey = props.couponKey;
    let betslipData = betslipContext.getBetslipData();
    const coupon = betslipData.coupons[couponKey];
    const tabAttivo = coupon.selectedContainer;
    const conf = getConfiguration();
    const containerOrder = conf.bco;
    function showContainer(container){
//    	betslipData.coupons[couponKey].selectedContainer = container;
    	betslipContext.changeContainer(container);
    }
    
    return (
        <div className="tab-pane active fade show" id="scUno" role="tabpanel">
            <div className="container-menu-navigazione-schedina">
                <div className="widget-schedina-nav bianco maiuscolo nav nav-tabs" role="tablist" id="nav-schedina-1">
                	{
                		Object.keys(containerOrder).map(function(key) {
                			const tabValue = containerOrder[key];
                			const reactKey = "container-" + tabValue + "-coupon-" + couponKey;
                			let label = null;
                			if(tabValue === 'singlebets'){
                				label = labels['betslip.single_bets'];
                			}
                			else if(tabValue === 'multibets'){
                				label = labels['betslip.multiple_bets'];
                			}
                			else {
                				label = labels['betslip.system_bets'];
                			}
                			return(
                			<a key={reactKey}
                			   className={"tasto-nav-quote-landing padding-verticale" + classIf(tabAttivo === tabValue, 'active')} 
                			   href-disabled="#" onClick={() => {showContainer(tabValue)}}>
                				{label}
                			</a>
                			)
                		})
                	}
                </div>
                <button className="padding-verticale" onClick={() => betslipContext.clearBetslip()}>
                    <p>{labels['betslip.empty_cart']}</p>
                    <i className="fas fa-trash-alt"></i>
                </button>
            </div>
            <div className="tab-content widget-schedina">
                {function() {
                    switch (tabAttivo) {
                        default:
                        case 'singlebets':
                            return <SingleBets couponKey={props.couponKey} />
                        case 'multibets':
                            return <MultipleBets couponKey={props.couponKey} />
                        case 'systembets':
                            return <SystemBets couponKey={props.couponKey} />
                    }
                }()}
            </div>
        </div>
    );
}

export default Coupon;